import { gql } from '@apollo/client';
import { UsersData } from './users_data';

export * from './qr_code';
export * from './verification-token';

export const GET_USER_BY_ID = gql`
query User_getById($id: String!) {
  User_getById(id: $id) {
    ${UsersData}
  }
}
`;

export const GET_USER_BY_FIREBASE_ID = gql`
query User_getByFirebaseId($id: String!) {
  User_getByFirebaseId(firebaseId: $id) {
    ${UsersData}
  }
}
`;

export const REGISTER_WITH_TOKEN = gql`
  mutation registerWithToken($registerWithTokenInput: RegisterWithTokenInput!) {
    registerWithToken(registerWithTokenInput: $registerWithTokenInput) {
      id
    }
  }
`;

export const LOGIN_WITH_TOKEN = gql`
  mutation loginWithToken($idToken: String!) {
    loginWithToken(idToken: $idToken)
  }
`;

export const LOGIN_WITH_USERNAME_AND_PASSWORD = gql`
  mutation loginWithUsername($username: String!, $password: String!) {
    users {
      loginWithUsername(loginWithUsernameInput: { username: $username, password: $password }) {
        customToken
      }
    }
  }
`;

export const LOGOUT_USER = gql`
  mutation logoutUser {
    users {
      logout
    }
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation changePassword {
    users {
      changePassword
    }
  }
`;
